"use strict";

import { DateHelper } from "../../../presentation/services/DateHelper/DateHelper";
import "./update-dialog.scss";
import "./update-dialog-dark.scss";

class UpdateDialogFinancialCtrl {
    constructor($mdDialog, DSNDialogService, locals) {
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.locals = locals;
        this.years = DateHelper.years(2010).reverse();
    }
    $onInit() {}
    onSubmit() {
        this.$mdDialog.hide(this.yearSelected);
    }
}

angular.module("nucont.shared").controller("updateDialogFinancialCtrl", [
    "$mdDialog",
    "DSNDialogService",
    "locals",
    UpdateDialogFinancialCtrl
]);
